module.exports = __webpack_public_path__ + "img/herb-cilantro-190x100.f939f628.jpg";